module.exports = __webpack_public_path__ + "img/holzdeck02.e693133c.jpg";